module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMlJREFUKBWV0TsOwjAMBuDf6UPMHIGJlRmJiZGtE69rcAjOQcvExshUiZmbcIC+TNyqCPpwwVIURbI/JzEwEHz2ZrIG0kBaQgnk2a3McdwlrdNHX34vVCPMGEsxEZ5QsE7oE7FAIpAFfQ1rQW3EBAIBxUXDvqAuhHb5VRg+OSsNe0MaIpCEhpXQL0hF9WPEkT9Fkd5lOtXHmqB+Tl3c3Fs3M97cgLP9P4igVSPb0E5UasUgDkcTcHIAmYi2Wdzsrp05dBfgYgPyjy8aKZXzwJaUTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/path.png
// module id = TyN9
// module chunks = 0